import { ProgramasGestionPage } from "@/features/programas";
import { Outlet, useLocation } from "react-router";

export default function Programas() {
  const location = useLocation();
  const isDetalles = location.pathname.includes("programas/detalles");

  if (isDetalles) {
    return <Outlet />;
  }

  return <ProgramasGestionPage scope="all" />;
}
